/*
 * File: /src/router/routes/voicemail.js
 * Created Date: Saturday December 28th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Saturday, 28th December 2019 3:06:47 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
const ListVoicemail = () =>
  import(/* webpackChunkName: "ValidDomain" */ 'src/components/Dashboard/Views/Voicemail/ListVoicemail.vue');

export const voicemailRoutes = [
  {
    path: 'voicemail/',
    name: 'List Voicemail',
    component: ListVoicemail
  },
];

